import { isNeededRedirectToValidateUser } from '@/config'
import utils from '@/utils/utils'
import { isValidToken } from '@/utils/session'

import {
  buildCloseSessionsPath,
  buildLoginPath,
  buildLogoutLoginPath,
  buildSignupPath,
  getFullReturnPath,
  resolvePostAuthPath,
} from '../utils/auth-return'

export {
  buildCloseSessionsPath,
  buildLoginPath,
  buildLogoutLoginPath,
  buildSignupPath,
  getFullReturnPath,
  resolvePostAuthPath,
}

/** Alinea auth context con utils legacy para rutas protegidas. */
export function canAccessProtectedRoute (auth = {}) {
  if (utils.isLogged()) {
    return true
  }

  const token = utils.getToken()

  return Boolean(
    auth.isAuthenticated &&
    auth.isInitialized &&
    token &&
    isValidToken(token)
  )
}

export function navigateAfterAuth (history, search = '') {
  const destination = resolvePostAuthPath(search)
  history.replace(destination)
}

export const redirectIfBannedUser = (user) => {
  if (user && !user.active && isNeededRedirectToValidateUser()) {
    window.location.replace('/validar-usuario')
    return true
  }
  return false
}

export const clearNotLoggedRedirectData = (utils) => {
  utils.removeDataNotLoggedUser()
}
